define.alias("shared/components/shared/ui/social-set-switcher/social-set", "calendar/components/shared/ui/social-set-switcher/social-set");